var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlideshow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "slideshow_svg__icon slideshow_svg__icon-tabler slideshow_svg__icon-tabler-slideshow",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 6h.01"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 18,
  height: 14,
  rx: 3
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m3 13 4-4a3 5 0 0 1 3 0l4 4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m13 12 2-2a3 5 0 0 1 3 0l3 3M8 21h.01M12 21h.01M16 21h.01"
})));
export default SvgSlideshow;